import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Routers from "../routes/Router";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { FetchSubAdminsDetails } from "../features/subAdmin/SubAdminSlice";
import { setTeacherName } from "../app/globalStore";
import { FetchCompanySettings } from "../features/slice";
import { FetchCompanyList } from "../features/company/CompanySlice";
import { toast } from "react-toastify";
function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mainAdminId = useSelector((store) => store.main.id);
  const authState = useSelector((store) => store.auth);
  const authAdminId = authState?.adminId;
  const id = mainAdminId || authAdminId;
  const data = useSelector((store) => store.subAdmin.detail);
  const companySettings = useSelector((store) => store.main.companySettings);
  const resolvedAdminType = (data?.admin_type || authState?.admin_type || "")?.toLowerCase();
  const resolvedModules = data?.modules || authState?.modules || {};
  const resolvedIsCompany = data?.is_company ?? (authState?.user_type === "company" || authState?.user_type === "teacher");
  const resolvedIsTeacher = data?.is_teacher ?? (authState?.user_type === "teacher" ? 1 : 0);
  const resolvedName = data?.name || authState?.name;

  if (resolvedName) {
    setTeacherName(resolvedName);
  }
  async function logout(e) {
    await localStorage.clear();
    // Clear all pagination state from sessionStorage on logout
    sessionStorage.clear();
    navigate("/");
  }

  // Clear sessionStorage when navigating from sidebar
  const handleSidebarNavigation = () => {
    // Clear all filter and pagination states from sessionStorage
    sessionStorage.clear();
  };

  const [openMenu, setOpenMenu] = useState(null);
  const [openSubMenu, setOpenSubMenu] = useState({});

  const toggleMenu = (index) => {
    setOpenMenu(openMenu === index ? null : index);
  };

  const toggleSubMenu = (key) => {
    setOpenSubMenu((prev) => ({
      ...prev,
      [key]: !prev?.[key]
    }));
  };

  // const [data, setData] = useState({});

  useEffect(() => {
    if (id) {
      dispatch(FetchSubAdminsDetails(id)).then((res) => {
        const userDetails = res?.payload?.data?.user_details;
        // Only fetch company list for super admins (not company admins)
        if (!userDetails?.is_company) {
          dispatch(FetchCompanyList({ page: 1, limit: 1000000 })).then((companyRes) => {
            if (companyRes?.payload?.code === 1 && companyRes?.payload?.data?.company_list) {
              localStorage.setItem(
                "companies",
                JSON.stringify(companyRes.payload.data.company_list)
              );
            }
          });
        }else{
           localStorage.removeItem("companies");
        }
      });
      dispatch(FetchCompanySettings());
    }
  }, [dispatch, id]);

  // Helper function to check if menu item is locked based on company settings
  // Returns object: { locked: boolean, reason: 'admin' | 'company' | null }
  const isMenuItemLocked = (subElement) => {
    // Super admins have full access - never show locks
    // If is_company is not set or false, user is super admin
    if (!data?.is_company) {
      return { locked: false, reason: null };
    }
    
    // Check for events menu items
    if (subElement.subname === "events" || subElement.subname === "event_Type") {
      if (companySettings?.admin_events === false) {
        return { locked: true, reason: 'admin' };
      }
      if (companySettings?.events === false) {
        return { locked: true, reason: 'company' };
      }
    }
    // Check for membership settings menu item
    if (subElement.subname === "membership") {
      if (companySettings?.admin_membership === false) {
        return { locked: true, reason: 'admin' };
      }
      if (companySettings?.membership === false) {
        return { locked: true, reason: 'company' };
      }
    }
    
    // Check for finance menu items
    if (subElement.subname === "finance") {
      if (companySettings?.admin_finance === false) {
        return { locked: true, reason: 'admin' };
      }
      if (companySettings?.finance === false) {
        return { locked: true, reason: 'company' };
      }
    }
    
    return { locked: false, reason: null }; // Not locked by default
  };

  // Handle click on locked menu items
  const handleLockedMenuClick = (reason) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (reason === 'admin') {
      toast.warning("This feature is currently disabled. Please contact support to activate this add-on.", { autoClose: false });
    } else if (reason === 'company') {
      toast.warning("You have kept this addon off. Please enable this addon from settings.", { autoClose: false });
    }
  };

  return (
    <div className="col-lg-4 store-sidebar admin-sidebar">
      <div className="shadow-part">
        <div className="d-flex flex-column align-items-center">
          <Link
            className="navbar-brand bg-none px-3 mx-lg-auto d-lg-block"
            to="/dashboard"
          >
            <img
              src={resolvedIsCompany ? (data?.image || "assets/images/headerlogo.png") : "assets/images/headerlogo.png"}
              className="img-fluid"
              alt="img"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = "assets/images/headerlogo.png";
              }}
            />
          </Link>
          {resolvedIsCompany && (
            <div 
              className="d-flex align-items-center mt-2"
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(resolvedIsTeacher === 1 ? `/edit-teacher/${data?.id || authState?.teacher_id}` : `/company/edit/${data?.id || authState?.company_id}`)}
            >
              <span className="text-info">{resolvedName}</span>
            </div>
          )}
        </div>
        <button
          className="btn btn-blue float-end menu-toggle d-lg-none"
          data-bs-target="#sidebar"
          data-bs-toggle="collapse"
        >
          <i className="fa fa-bars"></i>
        </button>
        <nav className="collapse d-lg-block" id="sidebar">
          <ul className="list-unstyled mb-0">
            {Routers?.map((props, i) => {
              if (props?.hidden || (props.subname === "company" && resolvedIsCompany) || (props?.superAdminOnly && resolvedAdminType !== "super admin")) {
                return null;
              } else {
                if (resolvedAdminType === "super admin") {
                  return (
                    <li key={i}>
                    <div className="menu-item" onClick={() => {
                      toggleMenu(i);
                      handleSidebarNavigation();
                    }}>
                      <Link
                            to={props.subname === "dashboard" ? "/dashboard" : props.subname === "company" ? "/company" : "#"} // Conditional path
                        className={props.subPath.some(path => window.location.pathname.split('/').filter(Boolean)[0] == path) ? "active" : ""}
                        onClick={() => handleSidebarNavigation()}
                      >
                        <div className="d-flex align-items-center">
                          <img
                            src={props.inactiveImage}
                            className="img-fluid sidebar-icon inactive-icon me-2"
                            alt=""
                          />
                          <img
                            src={props.activeImage}
                            className="img-fluid sidebar-icon active-icon me-2"
                            alt=""
                          />
                        <span>{props.name}</span>
                        </div>
                      </Link>
                    </div>
                    {props.subElements && props.subElements.length > 0 && (
                      <ul className={`list-unstyled ms-0  mb-0 submenu ${openMenu === i || props.subPath.some(path => window.location.pathname.split('/').filter(Boolean)[0] == path) ? "open" : ""}`}>
                      {props.subElements.map((subElement, j) => {
                        const lockStatus = isMenuItemLocked(subElement);
                        const nestedKey = `${i}-${j}`;
                        const hasChildren = subElement.subElements && subElement.subElements.length > 0;
                        const isNestedActive = subElement.subPath?.some(path => window.location.pathname.split('/').filter(Boolean)[0] == path);
                        return !subElement.hidden && subElement.subname !== "earning" ? (
                          <li key={j} className={`submenu-item`}>
                            <Link
                              to={lockStatus.locked ? "#" : subElement.path}
                              className={location.pathname.includes(subElement.subpath) ? "active" : ""}
                              onClick={(e) => {
                                if (lockStatus.locked) {
                                  return handleLockedMenuClick(lockStatus.reason)(e);
                                }
                                if (!hasChildren) {
                                  handleSidebarNavigation();
                                }
                                if (hasChildren) {
                                  e.preventDefault();
                                  toggleSubMenu(nestedKey);
                                }
                              }}
                            >
                              <p className={subElement.subPath.some(path => window.location.pathname.split('/').filter(Boolean)[0].includes(path)) ? "active" : ""}>
                                {subElement.name}
                                {lockStatus.locked && <i className="fa fa-lock ms-2" style={{fontSize: '14px', opacity: 0.9, color:"#D9B60D"}}></i>}
                              </p>
                            </Link>
                            {subElement.subElements && subElement.subElements.length > 0 && (
                              <ul className={`list-unstyled ms-3 mb-0 submenu ${openSubMenu?.[nestedKey] || isNestedActive ? "open" : ""}`}>
                                {subElement.subElements.map((child, k) => (
                                  !child.hidden ? (
                                    <li key={k} className="submenu-item">
                                      <Link
                                        to={child.path}
                                        className={child.subPath?.some(path => window.location.pathname.split('/').filter(Boolean)[0] == path) ? "active" : ""}
                                        onClick={() => handleSidebarNavigation()}
                                      >
                                        <p className={child.subPath?.some(path => window.location.pathname.split('/').filter(Boolean)[0].includes(path)) ? "active" : ""}>
                                          {child.name}
                                        </p>
                                      </Link>
                                    </li>
                                  ) : null
                                ))}
                              </ul>
                            )}
                          </li>
                        ) : null;
                      })}
                    </ul>
                    )}
                  </li>
                  );
                } else {
                  for (const key in resolvedModules) {
                    if (Object.hasOwnProperty.call(resolvedModules, key)) {
                      const element = resolvedModules[key];
                      if ( (key.includes(props.subname) && element === true) ||
                      (props.subElements?.some(sub => key.includes(sub.subname)) && element === true) ) {
                        return (
                          <li key={i}>
                          <div className="menu-item" onClick={() => {
                            toggleMenu(i);
                            handleSidebarNavigation();
                          }}>
                            <Link
                                  to={props.subname === "dashboard" ? "/dashboard" : props.subname === "company" ? "/company" : "#"} // Conditional path
                              className={props.subPath.some(path => window.location.pathname.split('/').filter(Boolean)[0] == path) ? "active" : ""}
                              onClick={() => handleSidebarNavigation()}
                            >
                              <div className="d-flex align-items-center">
                                <img
                                  src={props.inactiveImage}
                                  className="img-fluid sidebar-icon inactive-icon me-2"
                                  alt=""
                                />
                                <img
                                  src={props.activeImage}
                                  className="img-fluid sidebar-icon active-icon me-2"
                                  alt=""
                                />
                              <span>{props.name}</span>
                              </div>
                            </Link>
                          </div>
                          {props.subElements && props.subElements.length > 0 && (
                            <ul
                              className={`list-unstyled ms-0 mb-0 submenu ${
                                openMenu === i ||
                                props.subPath.some(
                                  path =>
                                    window.location.pathname.split("/").filter(Boolean)[0] == path
                                )
                                  ? "open"
                                  : ""
                              }`}
                            >
                              {props.subElements.map((subElement, j) => {
                                const lockStatus = isMenuItemLocked(subElement);
                                return data?.modules?.[subElement.subname] === true && element === true && subElement.subname !== "finance" && subElement.subname !== "fee-settings" ? (
                                  <li key={j} className="submenu-item">
                                    <Link
                                      to={lockStatus.locked ? "#" : subElement.path}
                                      className={location.pathname.includes(subElement.path) ? "active" : ""}
                                      onClick={(e) => {
                                        if (lockStatus.locked) {
                                          return handleLockedMenuClick(lockStatus.reason)(e);
                                        }
                                        handleSidebarNavigation();
                                      }}
                                    >
                                      <p
                                        className={location.pathname.includes(subElement.path) ? "active" : ""}
                                      >
                                        {subElement.name}
                                        {lockStatus.locked && <i className="fa fa-lock ms-2" style={{fontSize: '12px', opacity: 0.7}}></i>}
                                      </p>
                                    </Link>
                                  </li>
                                ) : null;
                              })}
                            </ul>
                          )}

                        </li>
                        );
                      }
                    }
                  }
                }
              }
            })}
            <li className="mt-1 d-none">
              <Link className="dropdown-item" to="/change-password">
                <span>change password</span>
              </Link>
            </li>
            {data?.modules?.settings && (
              <li>
                <Link className="dropdown-item" to="/settings" onClick={() => handleSidebarNavigation()}>
                  <span>
                    <i className="fa fa-gear" aria-hidden="true"></i> Settings
                  </span>
                </Link>
              </li>
            )}

            <li style={{marginTop: -20}}>
              <Link
                className="dropdown-item"
                to={() => {
                  return false;
                }}
                onClick={(e) => {
                  logout(e);
                }}
              >
                <span>
                  <i className="fa fa-sign-out" aria-hidden="true"></i> logout
                </span>
              </Link>
            </li>

            {/* <li className="">
              <a
                href="#setting"
                className="show-collape-border"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="setting"
              >
                <div>
                  <img
                    src="assets/images/Settings.png"
                    className="img-fluid sidebar-icon inactive-icon"
                    alt=""
                  />
                  <img
                    src="assets/images/Settings-selected.png"
                    className="img-fluid sidebar-icon active-icon"
                    alt=""
                  />
                </div>
                <span>setting </span>
              </a>
              <div className="collapse collapse-border" id="setting">
               
              </div>
            </li> */}
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default Sidebar;
